import React from "react";
import ReactDOM from "react-dom/client";

import App from "./App";
import { NuqsAdapter } from "nuqs/adapters/react";

import "./index.css";
import { QueryProviders } from "./providers/query.provider";
import { Toaster } from "./components/ui/sonner";
import { SidebarProvider } from "./components/ui/sidebar";
import { PostHogProvider } from "posthog-js/react";
import "driver.js/dist/driver.css";
import CrispChat from "./components/shared/crisp";
import { TooltipProvider } from "./components/ui/tooltip";

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Failed to find root element");
}
const options = {
  api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
};

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <PostHogProvider
      apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY}
      options={{
        ...options,
      }}
    >
      <TooltipProvider>
        <QueryProviders>
          <SidebarProvider>
            <NuqsAdapter>
              <App />
            </NuqsAdapter>
          </SidebarProvider>
          <Toaster position="bottom-right" />
          <CrispChat />
        </QueryProviders>
      </TooltipProvider>
    </PostHogProvider>
  </React.StrictMode>
);
